// 按钮权限 v-auth
import { store } from '@/store/index'

const hasAuth = (value) => {
  const { auth, user } = store.state
  // 超级管理员什么权限都有
  if (user.userInfo.currentRole === 'Admin') {
    return true
  }
  const flag = auth.buttonList.some((item) => item.code === value)
  return flag
}

/**
 *
 * @param {HTMLElement} el
 */
const inserted = (el, { value }) => {
  const f = hasAuth(value)
  if (f === false) {
    const newAuth = document.createComment('v-auth')
    el.parentNode.replaceChild(newAuth, el)
  }
}

export default {
  name: 'auth',
  inserted
}
